const style = {
  row: {
    border: `1px solid transparent`,
    padding: `20px`,
    borderBottom: `1px solid #f4f4f4`,
    cursor: `pointer`,
    ':hover': {
      border: `1px solid #ececec`,
      background: `#fbfbfb`,
      borderRadius: `3px`
    }
  },
  rowActive: {
    border: `1px solid #ececec`,
    background: `#fbfbfb`,
    borderRadius: `3px`
  },
  permRow: {
    overflow: `hidden`,
    transition: `0.2s`,
    maxHeight: `0`,
    padding: `0 20px`,
    borderColor: `#ececec`
    // background: `#f4f4f4`,
  },
  permRowActive: {
    padding: `10px 20px`,
    maxHeight: `100px`,
    borderTop: `1px solid #ececec`
  },
  header: {
    borderBottom: `1px solid #ececec`
  },
  expand: {
    fontSize: `12px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/GroupTable/style/list.js